import { render } from "./EventOpenModal.vue?vue&type=template&id=485a3d09"
import script from "./EventOpenModal.vue?vue&type=script&lang=ts"
export * from "./EventOpenModal.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QCard from 'quasar/src/components/card/QCard.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QForm,QCardSection,QCardActions,QBtn});
